import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResponseApi } from '../../../dtos/ResponseApi';
import { PalavraChaveResponse } from '../../../dtos/core/palavraChave/PalavraChaveResponse';

@Injectable({
  providedIn: 'root'
})
export class PalavraChaveService {
  private baseUrl = `${environment.apiUrl}/core/palavraChave`;

  constructor(private http: HttpClient) { }


  getAllPortal(): Observable<ResponseApi<PalavraChaveResponse[]>> {
    return this.http.get<ResponseApi<PalavraChaveResponse[]>>(`${this.baseUrl}/portal`);
  }

  getAllAdm(): Observable<ResponseApi<PalavraChaveResponse[]>> {
    return this.http.get<ResponseApi<PalavraChaveResponse[]>>(`${this.baseUrl}/adm`);
  }
}
